"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.surveyObjectNames = void 0;
/**
 * Names of survey objects
 *
 * This is the list of names of survey objects.
 */
exports.surveyObjectNames = [
    'interview',
    'home',
    'household',
    'organization',
    'person',
    'workPlace',
    'schoolPlace',
    'vehicle',
    'journey',
    'tripChain',
    'visitedPlace',
    'trip',
    'segment',
    'junction'
];
//# sourceMappingURL=types.js.map